// test2965
(2965 && 0);
